import type { ShapeDrawAction } from '~/store/frontendState/mapTools/shapeDraw/shapeDraw.action';
import {
  startShapeDraw, stopShapeDraw,
} from '~/store/frontendState/mapTools/shapeDraw/shapeDraw.actionCreators';
import distanceCalculatorCursor from '../../../../../../../assets/images/cursors/distance-calculator.png';
import { type MapComponentOptionsState } from '../mapComponentOptions.state';
import {
  type MapOptionsConfig, pop, push,
} from '../mapComponentOptionsStateOperations';

export const applyShapeDrawMapOptions = (
  state: MapComponentOptionsState,
  action: ShapeDrawAction,
  { priority }: MapOptionsConfig
) => {
  if (startShapeDraw.match(action)) {
    return push(state, {
      changeId: 'SHAPE_DRAW_ACTIVATE',
      priority,
      change: {
        draggableCursor: `url("${distanceCalculatorCursor}") 15 15, default`,
        clickableIcons: false,
        disableDoubleClickZoom: true,
      },
    });
  }

  if (stopShapeDraw.match(action)) {
    return pop(state, 'SHAPE_DRAW_ACTIVATE');
  }

  return undefined;
};
